import usdt from './abi/USDT.json'
import VaultProxy from './abi/VaultProxy.json'
import ausdt from './abi/AUSDT.json'

export const USDT = usdt as any
export const VAULTPROXY = VaultProxy as any
export const AUSDT = ausdt as any
